module.exports = __webpack_public_path__ + "img/c03_buildingstartechpullsaw_Normal_ua.4901a5b7.webp";